// To put a link in the definition, use the following syntax:
// [words to link](https://link.fr)

export const glossaryData = [
  {
    word: "ADEME",
    question: "Qu'est-ce que l'ADEME ?",
    definition:
      "L'ADEME est l'[Agence de la transition écologique](https://www.ademe.fr), un établissement public dont la vocation est d'accompagner la transition écologique et énergétique sous la tutelle du ministère de la Transition écologique. L'ADEME agit dans différents domaines, tels que la lutte contre le changement climatique, la préservation des ressources, la prévention et la gestion des déchets, la qualité de l'air et de l'eau, la mobilité durable, l'écoconception, l'écoconstruction et l'économie circulaire.",
  },
  {
    word: "Ampère",
    question: "Qu'est-ce qu'un ampère ?",
    definition:
      "L'ampère est une unité de mesure de l'intensité d'un courant électrique. L'ampère est symbolisé par la lettre A.",
  },
  {
    word: "Angle d'incidence",
    question: "Qu'est-ce que l'angle d'incidence ?",
    definition:
      "L'angle d'incidence est une donnée nécessaire lors du calcul de rentabilité d'une installation solaire photovoltaïque qui prend en compte l'angle des rayons du soleil sur la surface d'un panneau solaire.",
  },
  {
    word: "Anode",
    question: "Qu'est-ce qu'une anode ?",
    definition:
      "Une anode est une electrode où a lieu une réaction électrochimique d'oxydation (perte d'électrons) par opposition à la cathode où se produit une réaction électrochimique de réduction (gain d'électrons).",
  },
  {
    word: "Batterie",
    question: "Qu'est-ce qu'une batterie ?",
    definition:
      "Une batterie est un appareil destiné à stocker l'énergie électrique produite par les panneaux solaires photovoltaïques.",
  },
  {
    word: "Bifacial",
    question: "Qu'est-ce qu'un panneau solaire bifacial ?",
    definition:
      "La technologie bifacial est une technologie qui consiste à pouvoir produire de l'électricité à partir de la face arrière d'un panneau solaire grâce à l'effet naturel de l'albédo (réflectivité du sol). Un panneau solaire bifacial produit plus d'électricité qu'un panneau photovoltaïque classique.",
  },
  {
    word: "Cadre d'un panneau solaire",
    question: "Qu'est-ce que le cadre d'un panneau solaire ?",
    definition:
      "Le cadre d'un panneau solaire est une structure métallique qui entoure les cellules photovoltaïques et le verre du panneau solaire. Il protège les cellules photovoltaïques et le verre des chocs et des intempéries. Ils sont souvents en aluminium, noir, silver ou d'une autre couleur liée à l'esthétique du site, et leurs fonctions est d'assurer la rigidité et l'étanchéité du panneau solaire.",
  },
  {
    word: "Calepinage",
    question: "Qu'est-ce que le calepinage ?",
    definition:
      "Le calepinage est l'étape qui consiste à définir l'orientation des modules photovoltaïques sur le toit (portrait ou paysage), à implanter le quadrillage (lignes/colonnes) et à calculer le nombre optimal de panneaux solaires à disposer afin d'en tirer la meilleure puissance.",
  },
  {
    word: "Capacité de batterie",
    question: "Qu'est-ce que la capacité d'une batterie ?",
    definition:
      "La capacitée d'un batterie est exprimée en Ampère-heure (Ah), elle indique la quantité de courant que peut fournir une batterie au fil du temps.",
  },
  {
    word: "Circuit électrique",
    question: "Qu'est-ce qu'un circuit électrique ?",
    definition:
      "Un circuit électrique est un ensemble de conducteurs électriques connectés entre eux, permettant à un courant électrique de circuler.",
  },
  {
    word: "Clamp",
    question: "Qu'est-ce qu'un clamp ?",
    definition:
      "Un clamp désigne une pince intermédiaire ou d'extrémité utilisée pour fixer les modules solaires photovoltaïques aux rails.",
  },
  {
    word: "Conductance",
    question: "Qu'est-ce que la conductance ?",
    definition:
      "En électricité, la conductance est une grandeur qui mesure la capacité d'un corps à laisser passer un courant électrique. Elle est définie comme l'inverse de la résistance.",
  },
  {
    word: "Connexion réseau",
    question: "Qu'est-ce que la connexion réseau ?",
    definition:
      "La connexion réseau est l'etape permettant le raccordement d'une installation solaire photovoltaïque au réseau public afin de permettre la redistribution du surplus ou de la totalité d'électricité produite.",
  },
  {
    word: "Couplage",
    question: "Qu'est-ce que le couplage ?",
    definition:
      "Le couplage est un type de connexion électrique entre un réseau solaire et une batterie ou un stockage d'énergie.",
  },
  {
    word: "Crochet",
    question: "Qu'est-ce qu'un crochet de fixation ?",
    definition:
      "Un crochet de fixation est une attache mobile permettant de fixer les panneaux solaires photovoltaïques à une installation fixée sur une toiture.",
  },
  {
    word: "Eclisse de rail",
    question: "Qu'est-ce qu'une éclisse de rail ?",
    definition:
      "Une éclisse de rail est un type d'attache utilisé pour permettre la consolidation des joints des rails.",
  },
  {
    word: "Efficacité énergétique",
    question: "Qu'est-ce que l'efficacité énergétique ?",
    definition:
      "L'efficacité énergétique est le rapport entre le niveau d'énergie utile délivré et celui de l'énergie consommée, nécessaire au fonctionnement d'une installation photovoltaïque.",
  },
  {
    word: "EMS",
    question: "Qu'est-ce qu'un EMS ?",
    definition:
      "EMS est l'acronyme d'Energy Management System, désignant un gestionnaire de système énergétique permettant de surveiller, contrôler et optimiser les différentes performances d'un réseau électrique.",
  },
  {
    word: "EnR",
    question: "Qu'est-ce que les EnR ?",
    definition:
      "EnR est un acronyme pour Energie Renouvelable. Les énergies renouvelables sont des sources d'énergie qui se renouvellent naturellement et rapidement, à partir de ressources naturelles comme le soleil, le vent, l'eau, la biomasse ou la géothermie.",
  },
  {
    word: "EROI",
    question: "Qu'est-ce que l'EROI ?",
    definition:
      "L'EROI (nommé TRE en français) est le Taux de Retour Energétique. Il s'agit du rapport entre l'énergie qu'il faut fournir pour extraire un combustible et l'énergie que produira ce combustible.",
  },
  {
    word: "ETN",
    question: "Qu'est-ce qu'un ETN ?",
    definition: `ETN signifie "Etude de Technique Nouvelle". C'est une certification photovoltaïque pour les systèmes d'intégration et leur compatibilité avec des modules photovoltaïques. Souvent requise par les compagnies d'assurance. POwR Connect vous propose d'utiliser l'application [POwR Certifications](https://powr-certifications.fr) pour vérifier la compatibilité de vos modules avec des systèmes de fixation.`,
  },
  {
    word: "Etrier de terminaison",
    question: "Qu'est ce qu'un étrier de terminaison ?",
    definition:
      "Un etrier de terminaison est un etrier qui se fixe à la fin d'un rail lors d'une installation solaire photovoltaïque.",
  },
  {
    word: "Etrier intermédiaire",
    question: "Qu'est ce qu'un étrier intermédiaire ?",
    definition:
      "Un etrier intermédiaire est un etrier qui se fixe en milieu de rail lors d'une installation solaire photovoltaïque.",
  },
  {
    word: "Extension de garantie",
    question: "Qu'est-ce qu'une extension de garantie ?",
    definition:
      "L'extension de garantie est une prestation permettant d'étendre la garantie déjà existante d'un produit. ",
  },
  {
    word: "Intégration au bâti (IAB)",
    question: "Qu'est-ce que l'intégration au bâti (IAB) ?",
    definition:
      "L'intégration au bâti (IAB) est une technique d'installation de modules solaires qui consiste à les installer directement sur la toiture, en remplacement des tuiles ou des ardoises. ",
  },
  {
    word: "KvA",
    question: "Qu'est-ce qu'un kVA ?",
    definition: `KvA signifie "KiloVoltAmpère". C'est une unité de mesure qui correspond à 1000 VoltAmpère. Le kVA mesure la puissance active, c'est-à-dire la puissance réellement disponible de l'installation électrique.`,
  },
  {
    word: "Lithium",
    question: "Qu'est-ce que le lithium ?",
    definition:
      "Le lithium est l'élément chimique de numéro atomique 3 et de symbole Li. C'est un métal alcalin, très réactif, le lithium n'existe pas à l'état natif dans le milieu naturel, mais uniquement sous la forme de composés ioniques.",
  },
  {
    word: "Luminosité",
    question: "Qu'est-ce que la luminosité ?",
    definition:
      "La luminosité est une mesure de la quantité de lumière visible émise ou réfléchie par une source ou une surface. Elle est mesurée en lux, une unité qui correspond à la quantité de lumière reçue par une surface d'un mètre carré, éclairée par une source d'un candela.",
  },
  {
    word: "Onduleur",
    question: "Qu'est-ce qu'un onduleur solaire ?",
    definition:
      "Un onduleur solaire est un appareil qui transforme l'énergie du soleil en électricité utilisable. Il est indispensable pour les installations photovoltaïques, car il permet de convertir le courant continu produit par les panneaux solaires en courant alternatif, qui est le type de courant électrique utilisé dans les maisons et les entreprises.",
  },
  {
    word: "Profondeur de décharge d'une batterie",
    question: "Qu'est-ce que la profondeur de décharge d'une batterie ?",
    definition:
      "La profondeur de décharge (DOD) est un pourcentage qui indique la quantité d'énergie consommée par une batterie. Il est calculé en divisant la quantité d'énergie déchargée par la quantité d'énergie totale stockée dans la batterie.",
  },
  {
    word: "PTF",
    question: "Qu'est-ce qu'une PTF ?",
    definition:
      "La demande de Proposition Technique et Financière (PTF), ou le cas échéant, la demande de Proposition d'Entrée en File d'Attente (PEFA), est le premier pas dans le processus de raccordement. Le délai de traitement de la demande peut impacter le délai du projet avant que les travaux puissent débuter. Il est donc important d'anticiper la demande de raccordement.",
  },
  {
    word: "PTO",
    question: "Qu'est-ce qu'un PTO ?",
    definition:
      "Le PTO (Point de Terminaison Optique) est le point de connexion entre le réseau fibre optique et le réseau privé du client. Il est installé à l'intérieur du logement et se présente sous la forme d'un boîtier doté d'une prise optique. Le client branche son ONT (ou son modem s'il comprend un ONT interne) sur cette prise optique pour accéder au réseau fibre optique.",
  },
  {
    word: "QUALIPV",
    question: "Qu'est-ce que la qualification QUALIPV ?",
    definition:
      "QUALIPV est un label permettant aux installateurs posant des installations solaires photovoltaïques d'obtenir une qualification certifiante proposée par l'association [Qualit'EnR](https://www.qualit-enr.org/qualifications/qualipv).",
  },
  {
    word: "Rail",
    question: "Qu'est-ce qu'un rail de fixation ?",
    definition:
      "Dans le domaine du photovoltaïque, les rails permettent de supporter les panneaux solaires maintenus par des crochets de fixation.",
  },
  {
    word: "Résidentiel",
    question: "Qu'est-ce que le résidentiel ?",
    definition:
      "On nomme résidentiel, l'immobilier destiné à un usage d'habitation à titre de résidence. Le résidentiel est à destination des particuliers.",
  },
  {
    word: "RGE",
    question: "Qu'est-ce que le label RGE ?",
    definition: `RGE signifie "Reconnu Garant de l'Environnement", c'est un label qui est délivré par un organisme de certification à un installateur pour reconnaître son expertise dans le domaine. [L'organisme Qualit'EnR](https://www.qualit-enr.org/accueil-pro) répertorie les professionnels reconnus RGE.`,
  },
  {
    word: "Shelter",
    question: "Qu'est-ce qu'un shelter ?",
    definition:
      "Un shelter est un poste extérieur de transformation, comprenant onduleurs, transformateurs, cellules de protection, TGBT.",
  },
  {
    word: "Silicium",
    question: "Qu'est-ce que le silicium ?",
    definition:
      "Le silicium est un élément chimique présent naturellement dans la croûte terrestre. C'est un matériau semi-conducteur que l'on trouve quasiment dans tous les systèmes électroniques et qui est également utilisé dans la fabrication des panneaux solaires.",
  },
  {
    word: "Solaire passif",
    question: "Qu'est-ce que l'énergie solaire passive ?",
    definition:
      "Contrairement à l'énergie solaire active, l'énergie solaire passive est créée gratuitement par l'absorption des rayons du soleil à travers les fenêtres et les baies vitrées d'une maison. L'énergie est stockée dans les murs, le plafond et le plancher, puis diffusée en chaleur dans le logement.",
  },
  {
    word: "Solaire thermique",
    question: "Qu'est-ce que l'énergie solaire thermique ?",
    definition:
      "L'énergie solaire thermique consiste à piéger les rayons du soleil grâce à des capteurs thermiques. L'énergie créée est ensuite transmise à des absorbeurs métalliques qui diffusent de la chaleur et assurent le chauffage de l'eau sanitaire. Il s'agit du système utilisé par les chauffe-eau solaires notamment.",
  },
  {
    word: "Solaire thermodynamique",
    question: "Qu'est-ce que l'énergie solaire thermodynamique ?",
    definition:
      "L'énergie solaire thermodynamique consiste à capter le rayonnement du soleil via des miroirs de façon à générer des températures très élevées (de 400 à 1 000 °C). La chaleur obtenue transforme de l'eau en vapeur d'eau dans une chaudière. ",
  },
  {
    word: "Tedlar",
    question: "Qu'est-ce que le Tedlar ?",
    definition:
      "Le tedlar est une membrane de la famille des fluoropolymères, généralement blanche ou noire, sur la face arrière d'un panneau solaire monofacial qui permet de le protéger des agressions extérieures : corrosion, variation de température, etc…",
  },
  {
    word: "Terragrif",
    question: "Qu'est-ce que le Terragrif ?",
    definition:
      "Le terragrif est une lame métallique composée de denture-ressorts, positionnée entre le module photovoltaïque et la structure de montage, assurant l'équipotentialité d'une installation photovoltaïque.",
  },
  {
    word: "Tertiaire",
    question: "Qu'est-ce que le tertiaire ?",
    definition:
      "On nomme tertiaire, les bâtiments à usage professionnel : il peut s'agir de bureaux, commerces, etc.",
  },
  {
    word: "Wafer",
    question: "Qu'est-ce qu'un wafer ?",
    definition:
      "Un wafer est un composant d'une cellule photovoltaïque en forme de fine plaque de silicium produit à partir de lingot de silicium.",
  },
].sort((a, b) =>
  a.word
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .localeCompare(
      b.word
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    )
);
